import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import supabase from "../supabaseClient";

function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      const { error } = await supabase.auth.signOut();
      if (error) {
        console.error("Error logging out:", error.message);
      } else {
        navigate("/"); // Redirect to root page after logout
      }
    };

    handleLogout();
  }, [navigate]);

  return <div>Logging out...</div>;
}

export default Logout;
